<div class="dropdown">
  <button
    type="button"
    class="btn dropdown-toggle border d-flex flex-row align-items-center justify-content-between"
    data-bs-toggle="dropdown"
    id="navbarDropdownDetalle"
    aria-expanded="false"
    aria-haspopup="true">
  <div class="cluster-perfil">
    <div class="d-flex flex-row align-items-center justify-content-between">
      <div class="me-1">
        <h5 class="text-start m-0 p-0 name text3-tipografia-govco fw-bold"
        *ngIf="nombreUsuario">
          {{ nombreUsuario }}
        </h5>
        <h5 class="text-start m-0 p-0 detalle text4-tipografia-govco"
        *ngIf="numeroDocumentoUsuario">
          {{ numeroDocumentoUsuario }}
        </h5>
        <h5 class="text-start m-0 p-0 detalle text4-tipografia-govco"
        *ngIf="correoElectronico">
          {{ correoElectronico }}
        </h5>
      </div>
      <span class="govco-user-1 fs-3"></span>
    </div>
  </div>
  </button>

  <ul
    class="dropdown-menu dropdown-menu-end"
    aria-labelledby="navbarDropdownDetalle">

    <!-- Sección de roles (solo si hay más de un rol) -->
    <li *ngIf="mostrarRoles" class="px-3 py-2">
      <div class="roles-section">
        <div class="d-flex align-items-center mb-2">
          <span class="govco-icon-black-1 me-2"></span>
          <strong class="text4-tipografia-govco">Roles</strong>
        </div>
        <div class="roles-list">
          <div
            *ngFor="let rol of roles"
            class="role-item text4-tipografia-govco py-1 px-2 mb-1"
            [class.active-role]="esRolActivo(rol)"
            (click)="cambiarRol(rol)">
            {{ rol.Nombre }}
          </div>
        </div>
      </div>
    </li>

    <li *ngIf="mostrarRoles"><hr class="dropdown-divider"></li>

    <!-- Opciones de cuenta -->
    <li class="text-start">
      <button
        *ngIf="!isEmpresa"
        type="button"
        id="administrarCuenta"
        class="dropdown-item dir-menu-govco"
        (click)="administrarCuenta()"
        [attr.aria-label]="'menu.administrar-cuenta' | translate">
        {{ 'menu.administrar-cuenta' | translate }}
      </button>

      <button
        type="button"
        id="cerrarSesion"
        class="dropdown-item dir-menu-govco"
        (click)="logout()"
        [attr.aria-label]="'menu.cerrar-sesion' | translate">
        {{ 'menu.cerrar-sesion' | translate }}
      </button>
    </li>
  </ul>
</div>
